'use client';

import { FC, useState, useEffect } from 'react';
import styles from './ContactUsOptions.module.css';
import HotdeskButton from '@/hotdesk-ui/components/shared/HotdeskButton';
import { X } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { RemoteConfigKeys } from '@/hotdesk-ui/enum/remote-keys';
import { fetchRemoteConfig } from '@/hotdesk-ui/common-classes/firebase.service';
interface contactUsProps {
  listing?: Record<string, any>;
  manageContactSales?: () => void;
  onClose?: () => void;
}
const ContactUs: FC<contactUsProps> = ({
  listing,
  manageContactSales,
  onClose
}) => {
  const [remoteWhatsappLink, setRemoteWhatsappLink] = useState<string | null>(null);
  const t = useTranslations('workspace-details');
  console.log('listing', listing);
  const whatsappNumber = listing?.workspace?.metaData?.phoneNumber || listing?.metaData?.phoneNumber;
  // const whatsappUrl = whatsappNumber ? `https://wa.me/${whatsappNumber.replace(/[^0-9]/g, '')}` : null;
  const whatsappUrl = remoteWhatsappLink || (whatsappNumber ? `https://wa.me/${whatsappNumber.replace(/[^0-9]/g, '')}` : null);
  useEffect(() => {
    const loadRemoteWhatsappLink = async () => {
      try {
        const link = await fetchRemoteConfig(RemoteConfigKeys.WEB_WHATSAPP_LINK, 'string');
        setRemoteWhatsappLink(link as string);
      } catch (error) {
        console.error('Failed to fetch remote WhatsApp link:', error);
        setRemoteWhatsappLink(null);
      }
    };
    loadRemoteWhatsappLink();
  }, []);
  return <div className={styles.contactUsForm} data-sentry-component="ContactUs" data-sentry-source-file="ContactUsOptions.tsx">
        {onClose && <button type="button" className={styles.closeBtn} onClick={onClose} aria-label="Close">
                <X size={20} />
            </button>}

        <div className={styles.header}>
            <h2>{t('contactUs')}</h2>
        </div>
        
       {/* Contact Sales */}
        <HotdeskButton variant="secondary" size="md" fullWidth onClick={manageContactSales} data-sentry-element="HotdeskButton" data-sentry-source-file="ContactUsOptions.tsx">
            {t('contactSales')}
        </HotdeskButton>
        <div className={styles.join}>
            <span>{t('Or')}</span>
        </div>

        {/* WhatsApp */}
        {whatsappUrl ? <HotdeskButton as="link" variant="primary" size="md" fullWidth href={whatsappUrl} target="_blank" rel="noopener noreferrer" iconLeft={
    // eslint-disable-next-line @next/next/no-img-element
    <img src="/assets/icons/whatsapp-white.svg" alt="WhatsApp" width={20} height={20} />}>
                {t('chatWhatsApp')}
            </HotdeskButton> : <HotdeskButton variant="primary" size="md" fullWidth iconLeft={
    // eslint-disable-next-line @next/next/no-img-element
    <img src="/assets/icons/whatsapp-white.svg" alt="WhatsApp" width={20} height={20} />}>
                {t('chatWhatsApp')}
            </HotdeskButton>}
    </div>;
};
export default ContactUs;